import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'formatJobDate',
    standalone: false,
    pure: true
})
export class FormatJobDatePipe implements PipeTransform {
  transform(dateStr: string, format = 'EEE, MMM d'): string {
    if (!dateStr) {return '';}
    const date = DateTime.fromISO(dateStr);
    if (!date.isValid) {return '';}
    return date.toFormat(format);
  }
}
